import OnlyDesktop from './OnlyDesktop.vue'
import OnlyMobile from './OnlyMobile.vue'
import OnlyGameturbo from './OnlyGameturbo.vue'
import OnlyHorizontalScreen from './OnlyHorizontalScreen.vue'
import DesktopDisplayMobile from './DesktopDisplayMobile.vue'
import { game_detail_configs } from '@/config/games'

const is_display_desktop = (isMobile, gameName) =>
  !isMobile && game_detail_configs.has_desktopDetail_games.includes(gameName)
const is_display_gameTurbo = (isMobile, isTurbo) => isMobile && isTurbo
const is_display_mobile = (isMobile, isTurbo) => isMobile && !isTurbo
const is_desktop_display_mobile = (isMobile, gameName) =>
  !isMobile && game_detail_configs.desktop_display_mobile.includes(gameName)

export {
  is_display_desktop,
  is_display_gameTurbo,
  is_display_mobile,
  is_desktop_display_mobile,
  OnlyDesktop,
  OnlyMobile,
  OnlyGameturbo,
  OnlyHorizontalScreen,
  DesktopDisplayMobile,
}
